export default __webpack_public_path__ + "static/media/Gellix-Bold.0058174c.woff2";